import { useContext, useEffect, useState } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import GlobalContext from '../../../contexts/index';
import usePostData from '../../../hooks/usePostData';
import useFetchData from '../../../hooks/useFetchData';
import fields from '../fields';
import { useNavigate } from 'react-router-dom';
import translating from '../translate.json';
import { find } from 'lodash';

const AddUser = () => {
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const { postData, res, error } = usePostData();
  const [errFun, setErrFun] = useState();

  let { data: rolesList } = useFetchData('role');

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    else if (res?.id) {
      setLink(null);
      navigate('/users?added=true');
    }
  }, [res, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    let deepData = { ...data };
    // deepData.roleId = Object.keys(rolesList).find(key => rolesList[key].name === data.role);
    deepData.roleId = find(rolesList, { name: data.role })?.id;
    delete deepData.role;
    postData('user', deepData);
  };

  return (
    <div className="create-user">
      <SectionHeader title={translating.newUser}></SectionHeader>
      {rolesList && (
        <FormGroup
          fields={fields(rolesList, true)}
          onSubmit={onSubmit}
        ></FormGroup>
      )}
    </div>
  );
};

export default AddUser;
